/**
 * Espelha CriarNotaFiscalEntradaOcorrenciaRequest do OrquestradorCompras: anotação do usuário no histórico
 * da NF-e de entrada. Tipo, origem e usuário são postos pelo servidor.
 */
export class CriarNotaFiscalEntradaOcorrenciaRequest {
  /** Texto do usuário, até 1000 caracteres. */
  descricao: string;
  /** Data do fato, sem futuro; ausente = agora. */
  dataOcorrencia: Date | null = null;
}
